export const DEFAULT_COMPANY_CONFIG = {
  'name': "BO HEALTH LIMITED",
  'url': "https://app.bohealthelderly.com",
  'logo': "/assets/img/logo.png",
  'bg': "/assets/img/bg.jpg",
};